export function gridFields() {
  return Object.freeze([
      "state",
      {
        key: 'id',
        label: 'ID',
        sortable: true,
        variant: 'success'
      },
      {
        key: 'date',
        label: 'Date',
        sortable: true,
      },
      {
        key: 'fileName',
        label: 'Name',
        sortable: true,
      },
      {
        key: 'status',
        label: 'Status',
        sortable: true,
        variant: 'danger',
        formatter: function(val){
          switch (val) {
            case 'R':
              return "Ready"
            case 'F':
              return "Filling"
            case 'D':
              return "Getting Data"
          }
        }
      },
      "download"
  ]);
}
export const filterFields = [
  'filter.locNameFilter',
  'filter.codeFilter',
  'filter.locTypeFilter',
  'filter.activeFilter',
  'filter.statusFilter'
];
export const filter = {
  'locNameFilter': "",
  'codeFilter': "",
  'locTypeFilter': "",
  'activeFilter': "",
  'statusFilter': ""
};

